import { render, staticRenderFns } from "./SituacaoAcademica.vue?vue&type=template&id=0e3a4070&scoped=true&"
import script from "./SituacaoAcademica.vue?vue&type=script&lang=js&"
export * from "./SituacaoAcademica.vue?vue&type=script&lang=js&"
import style0 from "./SituacaoAcademica.vue?vue&type=style&index=0&id=0e3a4070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3a4070",
  null
  
)

export default component.exports